<template>
  <div class="login-container">
    <div class="login-card">

      <h2 class="login-title">球杆售后系统</h2>
      <p class="login-subtitle">请完成登录验证</p>

      <!-- 登录方式切换标签 -->
      <div class="login-type-switch">
        <div
            class="switch-item"
            :class="{ active: loginType === 'password' }"
            @click="changeLoginType('password')"
        >
          密码登录
        </div>
        <div
            class="switch-item"
            :class="{ active: loginType === 'code' }"
            @click="changeLoginType('code')"
        >
          验证码登录
        </div>
      </div>

      <el-form
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginRules"
          label-width="100%"
          label-position="top"
          class="login-form"
      >
        <!-- 仅保留手机号 -->
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input
              type="number"
              v-model="loginForm.phoneNumber"
              placeholder="请输入11位手机号"
              prefix-icon="el-icon-phone"
              maxlength="11"
              class="login-input"
          ></el-input>
        </el-form-item>

        <!-- 密码框：密码登录时显示 -->
        <el-form-item v-if="loginType === 'password'" label="密码" prop="password">
          <el-input
              v-model="loginForm.password"
              placeholder="请输入6-16位密码"
              prefix-icon="el-icon-lock"
              show-password
              class="login-input"
          ></el-input>
        </el-form-item>

        <!-- 验证码框：验证码登录时显示 -->
        <el-form-item v-if="loginType === 'code'" label="短信验证码" prop="code">
          <div class="code-input-wrap">
            <el-input
                v-model="loginForm.code"
                placeholder="请输入验证码"
                prefix-icon="el-icon-message"
                maxlength="6"
                class="login-input code-input"
            ></el-input>
            <el-button
                class="get-code-btn"
                :disabled="!canGetCode || countDown > 0"
                @click="getSmsCode"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 登录按钮 -->
        <el-form-item>
          <el-button
              type="primary"
              :loading="isLoading"
              @click="handleLogin"
              class="login-btn"
          >
            登录
          </el-button>
        </el-form-item>
        <!-- 忘记密码\注册入口 -->
        <div class="register-entry">
          <span class="register-link" @click="handleForPass">忘记密码</span>
          <span class="register-link" @click="handleRegister">注册会员</span>
        </div>

        <!-- 注册入口 -->
<!--        <div class="register-entry"  @click="handleRegister">-->
<!--          <span class="register-link">注册会员</span>-->
<!--        </div>-->
      </el-form>
      <!-- 调用提示语弹框组件 -->
      <MessageDialog
          v-if="showDialog"
          title="提示"
          :content="messageContent"
          confirmText="我知道了"
          :showCancel="false"
          @confirm="showDialog = false"
          @close="showDialog = false"
          closeOnMask
      />
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import {memberLogin, sendCode} from "@/api/sales";
import MessageDialog from "@/views/business/utils/messageDialog.vue";
import {mapActions} from "vuex";

export default {
  name: 'SalesLogin',
  components: {MessageDialog},
  data() {
    // 密码校验规则
    const validatePassword = (rule, value, callback) => {
      if (this.loginType === 'password' && !value) return callback(new Error('请输入密码'))
      if (this.loginType === 'password' && (value.length < 6 || value.length > 16)) {
        callback(new Error('密码长度需在6-16位之间'))
      } else {
        callback()
      }
    }

    // 验证码校验规则
    const validateCode = (rule, value, callback) => {
      if (this.loginType === 'code' && !value) return callback(new Error('请输入验证码'))
      if (this.loginType === 'code' && !/^\d{6}$/.test(value)) {
        callback(new Error('请输入6位数字验证码'))
      } else {
        callback()
      }
    }

    return {
      // 登录类型：password（密码）/ code（验证码）
      loginType: 'password',
      // 仅保留手机号、密码、验证码字段
      loginForm: {
        phoneNumber: '',
        password: '',
        code: ''
      },
      loginRules: {
        // 仅保留手机号、密码、验证码校验规则
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
        ],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      isLoading: false,
      // 验证码倒计时相关
      countDown: 0,
      canGetCode: false, // 是否可获取验证码（手机号校验通过）
      timer: null, // 倒计时定时器
      // 提示弹框组件
      showDialog: false,
      dialogTitle: '提示',
      messageContent: '',
      jumpTo: '',
    }
  },
  watch: {
    // 监听手机号变化，判断是否可获取验证码
    'loginForm.phoneNumber'(val) {
      this.canGetCode = /^1[3-9]\d{9}$/.test(val)
    },
    // 切换登录类型时重置对应字段和校验
    loginType() {
      if (this.loginType === 'password') {
        this.loginForm.code = '' // 清空验证码
      } else {
        this.loginForm.password = '' // 清空密码
      }
      // 重置表单校验
      this.$nextTick(() => {
        this.$refs.loginFormRef?.clearValidate()
      })
    }
  },
  mounted() {
    window.addEventListener('resize', this.adjustContainerHeight)
    // 初始化手机号校验状态
    this.canGetCode = /^1[3-9]\d{9}$/.test(this.loginForm.phoneNumber)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustContainerHeight)
    // 清除倒计时定时器
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    ...mapActions(['setToken']), // 映射setToken方法

    adjustContainerHeight() {
      const container = document.querySelector('.login-container')
      if (container) {
        container.style.minHeight = `${window.innerHeight}px`
      }
    },
    // 切换登录类型
    changeLoginType(type) {
      this.loginType = type
    },
    // 获取短信验证码
    async getSmsCode() {
      // 校验手机号
      if (!this.canGetCode) {
        Message.warning('请输入正确的11位手机号！')
        return
      }

      // 获取验证码接口请求
      try {
        const res = await sendCode(this.loginForm.phoneNumber,'login')
        if (res.code === 200) {
          this.showDialog = true
          this.dialogTitle = '提示'
          this.messageContent = '验证码已发送，请注意查收！'

          setTimeout(() => {
            this.showDialog = false
          }, 2000);
          // 开始倒计时（60s）
          this.countDown = 60
          this.timer = setInterval(() => {
            this.countDown--
            if (this.countDown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.showDialog = true
          this.dialogTitle = '提示'
          this.messageContent = res.returnMsg
        }
      } catch (error) {
        this.showDialog = true
        this.dialogTitle = '提示'
        this.messageContent = error.message || '网络异常，请稍后再试'
      }
    },
    // 登录逻辑（仅手机号+密码/验证码）
    async handleLogin() {
      try {
        // 表单校验
        await this.$refs.loginFormRef.validate()
      } catch (err) {
        this.showDialog = true
        this.dialogTitle = '提示'
        this.messageContent = '请检查表单填写是否正确！'
        return
      }

      this.isLoading = true
      try {
        // 根据登录类型组装参数（仅手机号+密码/验证码）
        const loginParams = {
          phoneNumber: this.loginForm.phoneNumber,
          // 密码/验证码二选一
          ...(this.loginType === 'password'
              ? { password: this.loginForm.password }
              : { captcha: this.loginForm.code })
        }

        const res = await memberLogin(loginParams);
        if (res.code === 200) {
          this.setToken(res.token)
          this.$router.replace('/app_home')
        } else {
          this.showDialog = true
          this.dialogTitle = '提示'
          this.messageContent = res.returnMsg
        }
      } catch (error) {
        this.showDialog = true
        this.dialogTitle = '提示'
        this.messageContent = error.message || '网络异常，请稍后再试'
      } finally {
        this.isLoading = false
      }
    },
    // 注册跳转
    handleRegister() {
      this.$router.replace('/sales_register');
    },
    //忘记密码
    handleForPass() {
      this.$router.replace('/sales_forget');
    },
  }
}
</script>

<style scoped lang="scss">
/* ===================== 公共基础样式（所有端通用） ===================== */
/* 全局基础 */
body {
  touch-action: manipulation;
  user-select: none;
  margin: 0;
  padding: 0;
}

/* 容器核心布局 */
.login-container {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #409eff, #67c23a);
}

/* 登录卡片核心 */
.login-card {
  position: relative;
  z-index: 1;
  background: #fff;
  border-radius: 24px;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

/* 标题通用样式 */
.login-title {
  color: #333;
  text-align: center;
  margin: 0 0 10px 0;
  font-weight: 700;
  padding-left: 10px;
}

.login-subtitle {
  color: #666;
  text-align: center;
  margin-bottom: 20px;
  padding-left: 10px;
}

/* 登录类型切换通用 */
.login-type-switch {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 24px;
  padding: 0 20px;
}

.switch-item {
  position: relative;
  cursor: pointer;
  padding: 8px 0;
  color: #999;
}

/* 选中态通用样式 */
.switch-item.active {
  color: #409eff;
  font-weight: 500;
}

.switch-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 2px;
  background-color: #409eff;
  border-radius: 1px;
}

/* 输入框通用样式 */
.login-input {
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 18px;
  margin-bottom: 4px;
  padding: 0 56px 0 48px;
}

/* 验证码输入容器通用 */
.code-input-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
}

.code-input {
  flex: 1;
  padding-right: 16px;
}

/* 获取验证码按钮通用 */
.get-code-btn {
  border: none;
  border-radius: 18px;
  background-color: #f5f7fa;
  color: #409eff;
  white-space: nowrap;
}

.get-code-btn:disabled {
  color: #999;
  background-color: #f0f0f0;
}

/* Element Input 通用深度样式 */
::v-deep .el-input__prefix {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 100%;
  transform: none;
}

::v-deep .el-input__prefix i {
  color: #409eff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

::v-deep .el-input__suffix {
  width: 40px;
  height: 40px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

::v-deep .el-input__suffix i {
  color: #409eff;
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

::v-deep .el-input__inner {
  height: 100%;
  line-height: 48px;
  font-size: 14px;
  border: none;
  padding: 0;
}

/* Element Form 通用深度样式 */
::v-deep .el-form {
  --el-form-border-color: transparent;
}

::v-deep .el-form-item__label {
  color: #555;
  margin-bottom: 10px;
  font-weight: 500;
}

::v-deep .el-form-item__error {
  font-size: 12px;
  padding-top: 2px;
  padding-left: 10px;
}

::v-deep .el-form-item {
  margin-bottom: 24px;
}

/* 登录按钮组通用 */
.login-btn-group {
  margin-top: 48px;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-bottom: 16px;
}

.login-btn {
  border: none;
  border-radius: 10px;
  background: #409eff;
  color: #fff;
}

.login-btn:hover {
  background: #3390ff;
}

/* 注册入口通用 */
.register-entry {
  /* 核心：启用 Flex 布局 */
  display: flex;
  /* 两端对齐（左span靠左，右span靠右） */
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 0;
}

.register-text {
  color: #666;
}

.register-link {
  color: #409eff;
  margin-left: 4px;
  position: relative;
}

.register-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #409eff;
  transition: width 0.3s ease;
}

.register-entry:hover .register-link::after {
  width: 100%;
}

/* ===================== 移动端适配（< 768px） ===================== */
@media screen and (max-width: 767px) {
  .login-container {
    width: 100vw;
    min-height: 100vh;
    padding: 0 20px;
  }

  .login-card {
    //width: 90%;
    max-width: 400px;
    padding: 40px 25px;
  }

  .login-title {
    font-size: 26px;
    margin-bottom: 10px;
    padding-left: 10px;
  }

  .login-subtitle {
    font-size: 15px;
    margin-bottom: 20px;
    padding-left: 10px;
  }

  /* 登录类型切换标签样式 */
  .login-type-switch {
    gap: 30px;
    margin-bottom: 24px;
    padding: 0 20px;
  }

  .switch-item {
    font-size: 16px;
    padding: 8px 0;
  }

  /* 选中态下划线 */
  .switch-item.active::after {
    width: 24px;
    height: 2px;
  }

  /* 输入框基础样式 */
  .login-input {
    height: 48px;
    font-size: 16px;
    border-radius: 18px;
    padding: 0 56px 0 48px;
    margin-bottom: 4px;
  }

  /* 前缀图标居中 */
  ::v-deep .el-input__prefix {
    width: 48px;
    height: 100%;
  }

  ::v-deep .el-input__prefix i {
    font-size: 18px;
  }

  /* 密码显隐按钮放大 */
  ::v-deep .el-input__suffix {
    width: 40px;
    height: 40px;
    right: 8px;
    top: 50%;
    padding: 0;
  }

  ::v-deep .el-input__suffix i {
    font-size: 24px;
    width: 100%;
    height: 100%;
  }

  /* 验证码输入框容器 */
  .code-input-wrap {
    gap: 10px;
  }

  .code-input {
    padding-right: 16px; /* 验证码框右侧无显隐按钮，减少内边距 */
  }

  /* 获取验证码按钮样式 */
  .get-code-btn {
    width: 110px;
    height: 48px;
    font-size: 14px;
    border-radius: 18px;
  }

  /* 输入框内容区 */
  ::v-deep .el-input__inner {
    height: 100%;
    line-height: 48px;
    font-size: 14px;
    padding: 0;
  }

  ::v-deep .el-form-item__label {
    font-size: 16px;
    margin-bottom: 10px;
  }

  ::v-deep .el-form-item__error {
    font-size: 12px;
    padding-top: 2px;
    padding-left: 10px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 24px;
  }

  /* 登录按钮组：调整间距，弥补删除字段后的空白 */
  .login-btn-group {
    margin-top: 48px;
    padding: 0;
    margin-bottom: 16px;
  }

  .login-btn {
    width: 100%;
    height: 48px;
    font-size: 17px;
    border-radius: 10px;
  }

  /* 注册入口样式 */
  .register-entry {
    padding: 8px 0;
  }

  .register-text {
    font-size: 14px;
  }

  .register-link {
    font-size: 14px;
    margin-left: 4px;
  }

  .register-link::after {
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
  }

  .register-entry:hover .register-link::after {
    width: 100%;
  }
}

/* ===================== 平板适配（768px ≤ 宽度 < 1200px） ===================== */
@media screen and (min-width: 768px) and (max-width: 1199px) {
  .login-container {
    min-height: 100vh;
    padding: 0 40px;
  }

  .login-card {
    width: 70%;
    max-width: 500px;
    padding: 50px 40px;
    border-radius: 28px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.18);
  }

  .login-title {
    font-size: 30px;
    margin-bottom: 15px;
  }

  .login-subtitle {
    font-size: 16px;
    margin-bottom: 28px;
  }

  .login-type-switch {
    gap: 40px;
    margin-bottom: 30px;
  }

  .switch-item {
    font-size: 18px;
    padding: 10px 0;
  }

  .switch-item.active::after {
    width: 28px;
    height: 2.5px;
  }

  .login-input {
    height: 52px;
    font-size: 17px;
    border-radius: 20px;
  }

  .get-code-btn {
    width: 120px;
    height: 52px;
    font-size: 15px;
    border-radius: 20px;
  }

  ::v-deep .el-form-item__label {
    font-size: 17px;
    margin-bottom: 12px;
  }

  .login-btn {
    width: 100%;
    height: 52px;
    font-size: 18px;
    border-radius: 12px;
  }

  .register-text, .register-link {
    font-size: 15px;
  }
}

/* ===================== PC 端适配（≥ 1200px） ===================== */
@media screen and (min-width: 1200px) {
  .login-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
    position: relative;
    padding: 0 50px;
  }

  .login-card {
    width: 100%;
    max-width: 520px;
    padding: 60px 50px;
    border-radius: 32px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .login-title {
    font-size: 32px;
    margin-bottom: 18px;
  }

  .login-subtitle {
    font-size: 17px;
    margin-bottom: 32px;
  }

  .switch-item {
    font-size: 18px;
    transition: color 0.2s ease;
  }

  .switch-item:hover:not(.active) {
    color: #409eff;
    opacity: 0.8;
  }

  .login-input {
    height: 56px;
    font-size: 17px;
    border-radius: 22px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  /* 输入框聚焦高亮 */
  ::v-deep .login-input:focus .el-input__inner {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  }

  .get-code-btn {
    width: 130px;
    height: 56px;
    font-size: 15px;
    border-radius: 22px;
    transition: all 0.2s ease;
  }

  .get-code-btn:not(:disabled):hover {
    background-color: #e8f4f8;
    color: #3390ff;
    transform: scale(1.02);
  }

  .get-code-btn:not(:disabled):active {
    transform: scale(0.98);
  }

  ::v-deep .el-form-item__label {
    font-size: 18px;
    margin-bottom: 14px;
  }

  .login-btn {
    width: 100%;
    height: 56px;
    font-size: 19px;
    border-radius: 14px;
    transition: all 0.2s ease;
  }

  .login-btn:hover {
    background: #3390ff;
    transform: scale(1.02);
  }

  .login-btn:active {
    transform: scale(0.98);
  }

  .register-entry {
    transition: transform 0.2s ease;
  }

  .register-entry:hover {
    transform: scale(1.05);
  }

  .register-text {
    font-size: 15px;
  }

  .register-link {
    font-size: 15px;
  }

  /* 前缀图标居中 */
  ::v-deep .el-input__prefix {
    top: 0;
    left: 0;
    width: 48px;
    height: 100%;
  }

  ::v-deep .el-input__prefix i {
    font-size: 18px;
  }

  /* 输入框内容区 */
  ::v-deep .el-input__inner {
    height: 100%;
    line-height: 48px;
    font-size: 17px;
    padding: 0;
  }

  ::v-deep .el-form-item__label {
    font-size: 18px;
    margin-bottom: 10px;
  }

  ::v-deep .el-form-item__error {
    font-size: 14px;
    padding-top: 2px;
    padding-left: 10px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 24px;
  }
}
</style>